import { SsoType } from '@diritto/common/account/constants/sso.constant';
import { AuthSsoAccessTokenRequestDto } from '@diritto/common/account/dtos/auth.dto';
import { MutateFn } from '@diritto/common/base/mutateFunction';
import { useMutation } from '@tanstack/react-query';
import { AccountApi } from 'api/ApiHelper';
import { accountsQueryKey } from 'queries/account/queryKey';

export const useSignInMutation = (callback: MutateFn) =>
  useMutation({
    mutationKey: accountsQueryKey.signIn,
    mutationFn: async (params: { ssoType: SsoType } & AuthSsoAccessTokenRequestDto) =>
      AccountApi.signWithSsoAccessToken(params.ssoType, params),
    ...callback,
  });
